import { useNavigate } from 'react-router-dom';
import { useCustomerId, useURLparams } from '@hooks';
import { Table } from '@molecules';
import { trackings } from '@utils';
import { COLUMNS, DEFAULT_PAGE_LIMIT, NamelessCardBulk } from '../constants';
import useSearchNamelessCardsBulk from '../data/useSearchNamelessCardsBulk';
import { NAMELESS_CARDS_DETAIL_CLICK_EVENT } from '../events';

/**
 * List of nameless cards bulks.
 */
const List = () => {
  const { params, setURLparams } = useURLparams<{ page: number; limit: number }>();
  const { customerId } = useCustomerId();
  const navigate = useNavigate();
  const { data, isLoading, handleRowsPerPageChange, handlePageChange } = useSearchNamelessCardsBulk(
    { customerId, params, setURLparams }
  );

  /** Navigate to detail page */
  const navigateToDetail = (row: NamelessCardBulk) => {
    trackings(NAMELESS_CARDS_DETAIL_CLICK_EVENT);
    navigate(`/tarjetas-innominadas/mis-altas/${row.id}`, { state: row });
  };

  return (
    <Table
      count={data?.totalCount || 0}
      columns={COLUMNS}
      items={data?.page}
      onPageChange={handlePageChange as (...args: Event[]) => null}
      onRowsPerPageChange={handleRowsPerPageChange as (...args: Event[]) => null}
      page={params.page || 1}
      rowsPerPage={params.limit || DEFAULT_PAGE_LIMIT}
      onItemClick={navigateToDetail}
      isLoading={isLoading}
    />
  );
};

export default List;
